import { dayjs } from "@/utils/dayjs";
import { truncateFileNameMiddle } from "@/utils/string";

const MAX_LENGTH = 30;
const ELLIPSIS = "...";

/**
 * Renders a filename with the updatedAt date inlined before the extension
 * (e.g. `report20251119.pdf`). Falls back to middle-truncation when no date
 * is provided or the combined string still exceeds MAX_LENGTH.
 */
export const formatFileNameWithDate = (fileName: string, updatedAt?: string | null): string => {
  if (!updatedAt || !fileName) return truncateFileNameMiddle(fileName, MAX_LENGTH);

  const formattedDate = dayjs(updatedAt).format("YYYYMMDD");
  const lastDotIndex = fileName.lastIndexOf(".");
  const namePart = lastDotIndex !== -1 ? fileName.substring(0, lastDotIndex) : fileName;
  const extPart = lastDotIndex !== -1 ? fileName.substring(lastDotIndex) : "";

  const combinedName = `${namePart}${formattedDate}${extPart}`;
  if (combinedName.length <= MAX_LENGTH) return combinedName;

  const maxNameLength = MAX_LENGTH - ELLIPSIS.length - formattedDate.length - extPart.length;
  if (maxNameLength > 0) {
    return `${namePart.substring(0, maxNameLength)}${ELLIPSIS}${formattedDate}${extPart}`;
  }
  return truncateFileNameMiddle(combinedName, MAX_LENGTH);
};
